export default validationRule => (values, props) => {
  const {errors} = validationRule(values, props);
  let validationErrors = {};

  errors.forEach(error => {
    var path = error.property.split(".");

    for (var i = 0, currentObject = validationErrors; i < path.length - 1; i++) {
       currentObject = currentObject[path[i]] = currentObject[path[i]] || {};
    }

    if(Array.isArray(error.actual)) {
      if(!currentObject[path[i]]) {
        currentObject[path[i]] = {};
      }
      currentObject[path[i]]['_error'] = error.message; 
    } else {
      currentObject[path[i]] = error.message; 
      //unable to understand what next line is doing - seems it's redundant, it's setting errors in wrong format
      //validationErrors[error.property] =  error.message;
    }
  });

  return validationErrors;
}


// WEBPACK FOOTER //
// ./src/tools/validation/index.js